export const website = {
  firstStep: {
    title: "Los geht's! Welche Vorlage möchten Sie verwenden?",
    subtitle:
      "Bereit für eine beeindruckende Website? Beginnen wir mit den Vorlagen, danach geht es an die Farben.",
  },
  secondStep: {
    title: "Welche Farbpalette passt am besten zu Ihrer Marke?",
    subtitle: "Gestalten Sie Ihre Vorlage mit einem Hauch Farbe",
  },
  thirdStep: {
    title: "Haben Sie tolle Fotos von Ihrer Unterkunft?",
    titleLine2: "Laden Sie sie hoch!",
    subtitle: "Laden Sie das beste Foto Ihrer Unterkunft für die Startseite hoch",
  },
  fourthStep: {
    title: "Super. Wie wäre es mit einem Namen für Ihr Unternehmen?",
    subtitle:
      "Name und Slogan eines Unternehmens steigern den Wiedererkennungswert und stärken Ihr Markenbild.",
  },
  fifthStep: {
    title: "Haben Sie ein Logo für Ihre Marke?",
    subtitle:
      "Für das beste Ergebnis verwenden Sie eine Vektorgrafik oder ein PNG mit transparentem Hintergrund. Die idealen Seitenverhältnisse sind 2:1 oder 1:1 (quadratisches Bild). Die Größe sollte 400 px x 192 px betragen (Mindesthöhe 60 px). Wenn Sie noch kein Logo haben, verwenden wir Ihren Firmennamen als Marke.",
  },
  livingstone: {
    navMain: "Hauptmenü",
    navProperty: "Unterkunft",
    navMap: "Karte",
    navGallery: "Galerie",
    navRates: "Tarife",
    navAvailability: "Verfügbarkeit",
    navReviews: "Bewertungen",
    bookNow: "Jetzt buchen",
    checkinCheckout: "Anreise → Abreise",
    guests: "Gäste",
  },
  tideway: {
    navMain: "Hauptmenü",
    navProperty: "Unterkunft",
    navMap: "Karte",
    navGallery: "Galerie",
    navRates: "Tarife",
    navAvailability: "Verfügbarkeit",
    navReviews: "Bewertungen",
    bookNow: "Jetzt buchen",
    checkinCheckout: "Anreise → Abreise",
    guests: "Gäste",
  },
};
